import React from 'react';
import { Translation } from 'react-i18next';

import CommonPopup from 'components/common/CommonPopup';

import './AdsenseInfoIcon.css';

const AdsenseInfoIcon = () => (
  <Translation>
    {(t) => (
      <CommonPopup
        key="adsense-info-icon-popup-key"
        questionIcon
        type="info"
        className="adsense-info-icon__component"
      >
        <div className="popup-wrapper">
          <div className="header">
            <div className="icon" />
          </div>
          <div className="publisher-id">
            <div className="label">{t("Publisher ID")}</div>
            <div className="value">pub-0123456789XXXXXX</div>
          </div>
          <div className="text">{t("A unique identifier for your account.")}</div>
          <div className="text">{t("It is located in AdSense if you follow the path:")}</div>
          <div className="text">{t("Account -> Settings -> Account Information")}</div>
        </div>
      </CommonPopup>
    )}
  </Translation>
);

export default AdsenseInfoIcon;
